import React from 'react'

import LetterLanding from '../LetterLanding';

import logo_target from '../../../images/letterfunnel/renature.webp';
import screenshot_target from '../../../images/letterfunnel/marcodeboer.webp';


export default class extends React.Component {

  // variable "competition" is optional, fallback: "jouw B2B concurrenten".
  render() {
    return <LetterLanding
      fullname="Marco de Boer"
      firstname="Marco"
      companyname="reNature"
      competition="Commonland en Climate Farmers"
      logo_target={logo_target}
      screenshot_target={screenshot_target}
    />;
  }

}



// WEBPACK FOOTER //
// ./src/containers/letterfunnel/landings/marcodeboer.js